export default "__VITE_ASSET__CuYIV4f1__"